import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRouter from './AppRouter';

// 전역 마이그레이션/캐시 방지 로직 (사용자 환경 자동 복구)
(function bootstrapMigrations() {
  try {
    const APP_VERSION = '2025-10-28-1';
    const storedVersion = localStorage.getItem('oneline_app_version');

    // 1) 오래된 커스텀 설정 자동 정리
    const model = localStorage.getItem('oneline_model');
    if (model === 'oneline-custom') {
      localStorage.setItem('oneline_model', 'oneline-chat');
    }

    // 2) 세션/포인트 트랜잭션 과다시 자동 슬림화
    const slimJsonArray = (key, keep = 200) => {
      try {
        const arr = JSON.parse(localStorage.getItem(key) || '[]');
        if (Array.isArray(arr) && arr.length > keep) {
          localStorage.setItem(key, JSON.stringify(arr.slice(-keep)));
        }
      } catch (_) {
        // 파손된 경우 초기화
        localStorage.setItem(key, '[]');
      }
    };
    slimJsonArray('ai_agent_sessions', 50);
    slimJsonArray('ai_agent_points_tx_v1', 200);
    slimJsonArray('ai_agent_guest_tx_v1', 100);

    // 3) 앱 버전 변경 시 캐시 무효화 힌트 저장 (서비스워커/정적 캐시 환경 고려)
    if (storedVersion !== APP_VERSION) {
      localStorage.setItem('oneline_app_version', APP_VERSION);
      // 강제 전체 캐시 클리어는 위험하므로, 다음 로드시 최신 번들 사용 유도만 수행
      // 필요 시 아래 라인을 주석 해제하여 1회 강제 리로드
      // window.location.reload(true);
    }
  } catch (e) {
    console.warn('초기 마이그레이션 스크립트 실패:', e);
  }
})();

// Chatway 실시간 상담 스크립트 동적 주입
(function injectChatwayWidget() {
  try {
    if (document.getElementById('chatway')) return;
    const s = document.createElement('script');
    s.id = 'chatway';
    s.async = true;
    s.src = 'https://cdn.chatway.app/widget.js?id=Z9GYJepMT0jo';
    // readiness promise
    if (!window.__chatwayReadyResolve) {
      window.__chatwayReadyPromise = new Promise((resolve) => {
        window.__chatwayReadyResolve = resolve;
      });
    }
    
    // Chatway 위젯 접근성 문제 해결: aria-hidden 제거
    function fixChatwayAccessibility() {
      // launcher-minimize-icon 버튼 찾기
      const minimizeButtons = document.querySelectorAll('button.launcher-minimize-icon, button.launcher-icon.launcher-minimize-icon');
      minimizeButtons.forEach(btn => {
        // aria-hidden이 true로 설정되어 있으면 제거
        if (btn.getAttribute('aria-hidden') === 'true') {
          btn.removeAttribute('aria-hidden');
        }
      });

      // 다른 Chatway 관련 버튼들도 확인
      const chatwayButtons = document.querySelectorAll('[class*="chatway"], [id*="chatway"], [class*="launcher"]');
      chatwayButtons.forEach(btn => {
        if (btn.tagName === 'BUTTON' && btn.getAttribute('aria-hidden') === 'true') {
          // 포커스를 받을 수 있는 버튼인지 확인
          const tabIndex = btn.getAttribute('tabindex');
          if (tabIndex !== '-1' || btn.offsetParent !== null) {
            // 포커스를 받을 수 있는 버튼이면 aria-hidden 제거
            btn.removeAttribute('aria-hidden');
          }
        }
      });
    }

    const widgetLoadStart = Date.now();
    let observer = null;
    let checkInterval = null;

    s.onload = () => {
      // Some widgets init after onload; poll a bit for API surface
      const start = Date.now();
      const timer = setInterval(() => {
        if (window.Chatway && typeof window.Chatway.open === 'function') {
          clearInterval(timer);
          try { window.__chatwayReadyResolve && window.__chatwayReadyResolve(true); } catch (_) {}
        } else if (Date.now() - start > 8000) {
          clearInterval(timer);
          try { window.__chatwayReadyResolve && window.__chatwayReadyResolve(false); } catch (_) {}
        }
      }, 150);

      // 위젯이 로드될 때까지 기다린 후 접근성 수정
      // MutationObserver로 DOM 변경 감지
      observer = new MutationObserver(() => {
        fixChatwayAccessibility();
      });

      // 문서 전체 감시 시작
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'class']
      });

      // 즉시 한 번 실행
      setTimeout(fixChatwayAccessibility, 500);
      setTimeout(fixChatwayAccessibility, 1500);
      setTimeout(fixChatwayAccessibility, 3000);

      // 주기적으로 확인 (위젯이 늦게 로드될 수 있음)
      checkInterval = setInterval(() => {
        fixChatwayAccessibility();
        // 30초 후에는 중단
        if (Date.now() - widgetLoadStart > 30000) {
          clearInterval(checkInterval);
          if (observer) observer.disconnect();
        }
      }, 2000);
    };
    document.body.appendChild(s);
  } catch (e) {
    console.warn('Chatway 위젯 주입 실패:', e);
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);
